import React, { useEffect, useRef, useState } from 'react'
import _ from 'lodash'
import CodeMirror from 'codemirror'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/lint/json-lint'

const CodeMirrorComponent = (props) => {
  const { value = '', onChange = _.noop } = props

  const [editor, setEditor] = useState(null)
  const cmEl = useRef()

  useEffect(() => {
    const cm = CodeMirror(cmEl.current, {
      mode: 'javascript',
      indentUnit: 2
    })

    setEditor(cm)

    cm.setSize(600, 400)
    cm.on('change', () => {
      const value = cm.getValue()
      onChange(value)
    })
  }, [onChange])

  useEffect(() => {
    if (!editor) {
      return
    }

    editor.setValue(value)
  }, [editor, value])

  return <div className='codemirror-container bot-settings' ref={cmEl} />
}

export default CodeMirrorComponent
